// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"8f96f7107abf66cf6630","764":"0b2bd7c5afd6d026317e"}[chunkId] + ".css";
};